<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2>Welcome Stash Busting Scarf Weave-Along Participants!</h2>

        <img style="float: left; width: 40%; max-width: 28rem; padding-left: 1rem; padding-right: 1rem;" :src='this.getSiteImageUrl("scarf-weave-along-yarn.jpg")' />

        <div class='top-padding'>
            If you've enjoyed using the Color Editor to design your scarves, imagine using it to design with any of the 74,000+ 
            drafts in our collection - or ANY draft that you design yourself!
        </div>

        <div class='top-padding'>
            And - for a limited time only - we have a SPECIAL OFFER for Weave-Along participants! If you join Handweaving.net as a new subscriber, you'll get 
            THREE MONTHS FREE with your first year's subscription. That's right - pay for nine months and get a full year's subscription. 
            This offer is ONLY good for Weave-Along participants, because we know how much you love color! (New subscribers only.)
        </div>

        <div class="right-padding bottom-padding top-padding">
            <b-button variant='primary' @click='navigateToSubscription'>Join Today! &raquo;</b-button>
        </div>                

        <div style='clear: both' class='top-padding bottom-padding'>
            Here are just a few of the 74,000+ drafts that are available to Handweaving.net subscribers: 
            
        </div>

        <img style='vertical-align: top; padding-right: 0.5rem; padding-bottom: 0.5rem' :src='this.getSiteImageUrl("63609-4-tr.png")' />
        <img style='vertical-align: top; padding-right: 0.5rem; padding-bottom: 0.5rem' :src='this.getSiteImageUrl("63576-4-tr-2.png")' />
        <img style='vertical-align: top; padding-right: 0.5rem; padding-bottom: 0.5rem' :src='this.getSiteImageUrl("63611-4-tr.png")' />
        <img style='vertical-align: top; padding-right: 0.5rem; padding-bottom: 0.5rem' :src='this.getSiteImageUrl("71695-4-tr.png")' />
        <img style='vertical-align: top; padding-right: 0.5rem; padding-bottom: 0.5rem' :src='this.getSiteImageUrl("10707-4-tr.png")' />
    </b-container>

</template>

<script>

import mediaService from '../mixins/mediaService.js'

export default {
    mixins: [mediaService],
    components: {
    },
    methods: {
        navigateToSubscription() {
            this.$router.push({ name: 'Subscription' })
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Stash Busting Scarf Weave-Along Promotion')
        this.$store.commit('setDiscountPlanID', 'tc-weave-along-25')
        this.$store.commit('setDiscountPlanMessage', 'Regularly $25/year, Stash Busting Scarf special for new subscribers - THREE FREE MONTHS your first year - just $18.75 your first year!')
    }
}
</script>

<style scoped>
.maxLogoHeight {
    max-height: 90px;
    height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/WeaveAlongPromo.vue